import React from 'react';
import TeamShirt from "./TeamShirt";

const renderTeamPossessionButton = (team, activeTeamId, shirtColor, onClick) => {
    let className = "possession-team-container transparent-black-bg";
    let style = {};

    if (team.id === activeTeamId) {
        style.background = shirtColor;
    }

    return (
        <div style={style} className={className} onClick={() => onClick(team.id)}>
            <TeamShirt color={shirtColor} style={{
                width: "70%",
                margin: "15%",
                height: "60%"
            }} />
        </div>
    )
};

const renderSeperatorButton = (duration, onClick) => {

    if (duration !== null) {
        return (
            <div className="transparent-black-bg possession-separator" onClick={() => onClick(null)}>
                <div className="text-center text-outline">
                    {duration.toFixed(0)}
                </div>
            </div>
        );
    }

    return (
        <div className="possession-separator" style={{background: "rgba(150,0,0,0.5)"}} />
    );
};

const PossessionTrackingDisplay = ({homeTeam, visitingTeam, activeTeamId, homeTeamColor, visitingTeamColor, possessionDuration, onClick}) => {

    return (
        <div className="possession-tracking-container">
            {renderTeamPossessionButton(homeTeam, activeTeamId, homeTeamColor, onClick)}
            {renderSeperatorButton(possessionDuration, onClick)}
            {renderTeamPossessionButton(visitingTeam, activeTeamId, visitingTeamColor, onClick)}
        </div>
    );
};

export default PossessionTrackingDisplay;



// WEBPACK FOOTER //
// ./src/js/PossessionTrackingDisplay.js